<template>
  <time :datetime="isoDate" :title="fullFormattedDate">{{ formattedDate }}</time>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { DateValue, formatDate, formatLongDate, formatMediumDate } from "@/helpers/date-utils";

export default Vue.extend({
  name: "LocalizedDate",
  props: {
    date: [Temporal.PlainDate, String] as unknown as PropType<DateValue>,
    locale: String,
    format: {
      type: String,
      default: "numeric",
      validator: (value: string) => value === "numeric" || value === "long",
    },
  },
  computed: {
    isoDate(): string {
      if (!this.date) return "";
      try {
        if (this.date instanceof Temporal.PlainDate) return this.date.toString();
        if (typeof this.date !== "string") return "";
        return Temporal.PlainDate.from(this.date).toString();
      } catch {
        return "";
      }
    },
    formattedDate(): string {
      if (!this.date) return "";
      return this.format === "long"
        ? formatLongDate(this.date as DateValue, this.locale)
        : formatDate(this.date as DateValue, this.locale);
    },
    fullFormattedDate(): string {
      if (!this.date) return "";
      return formatMediumDate(this.date as DateValue, this.locale);
    },
  },
});
</script>
